import React from "react";
import { useNavigate } from "react-router-dom";

import {
  LogOut,
  ShieldCheck,
  FileText,
  UserRound,
} from "lucide-react";

const LOGO_ONE = "/assets/images/logo1.png";
const LOGO_TWO = "/assets/images/logo2.png";

const ApplicationHeader = () => {
  const navigate = useNavigate();

  const userEmail =
    localStorage.getItem("ogfzaRegistryPortalUser") || "Applicant";

  const handleLogout = () => {
    localStorage.removeItem("ogfzaRegistryPortalLoggedIn");
    localStorage.removeItem("ogfzaRegistryPortalUser");
    navigate("/portal/login");
  };

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-slate-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-5 py-4 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2 shrink-0">
            <div className="w-12 h-12 rounded-xl bg-white border border-slate-200 shadow-sm p-1.5">
              <img
                src={LOGO_ONE}
                alt="OGFZA Logo One"
                className="w-full h-full object-contain"
              />
            </div>

            <div className="w-12 h-12 rounded-xl bg-white border border-slate-200 shadow-sm p-1.5">
              <img
                src={LOGO_TWO}
                alt="OGFZA Logo Two"
                className="w-full h-full object-contain"
              />
            </div>
          </div>

          <div>
            <p className="text-[11px] md:text-xs uppercase tracking-[0.18em] text-[#026b07] font-black">
              OGFZA Digital Registry
            </p>

            <h1 className="text-sm md:text-lg font-black text-[#201182] leading-tight">
              Operation Licence Registration Portal
            </h1>

            <p className="text-xs text-slate-500 mt-1">
              Isolated application environment
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center gap-3">
          <div className="hidden md:flex items-center gap-2 rounded-full bg-[#201182]/5 border border-[#201182]/10 px-4 py-2 text-xs font-semibold text-[#201182]">
            <ShieldCheck size={15} />
            Secure Portal Session
          </div>

          <div className="flex items-center gap-2 rounded-full bg-slate-50 border border-slate-200 px-4 py-2 text-xs font-medium text-slate-600">
            <UserRound size={15} className="text-[#026b07]" />
            <span className="max-w-[180px] truncate">{userEmail}</span>
          </div>

          <button
            type="button"
            onClick={() => navigate("/portal/registry-portal")}
            className="inline-flex items-center justify-center gap-2 rounded-full border border-slate-300 bg-white px-5 py-2.5 text-xs md:text-sm font-bold text-slate-700 hover:border-[#201182] hover:text-[#201182] transition-all"
          >
            <FileText size={16} />
            Application
          </button>

          <button
            type="button"
            onClick={handleLogout}
            className="inline-flex items-center justify-center gap-2 rounded-full bg-[#201182] px-5 py-2.5 text-xs md:text-sm font-bold text-white hover:bg-[#026b07] transition-all"
          >
            <LogOut size={16} />
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default ApplicationHeader;